import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { GOOGLE } from '@rsos/maps/constants/mapProviders';
import { AxonGLNext } from './Axon/useAxonGLNext';
import CallsGL from './CallsGL/CallsGL';
import DynamicLayersGL from './DynamicLayersGL/DynamicLayersGL';
import { EagleEyeGL } from './EagleEye/useEagleEye';
import { GisSearchGL } from './GisSearchGL';
import JurisdictionGL from './JurisdictionGL';
import MapPopover from './MapPopover';
import IncidentMapPopover from './MapPopover/IncidentMapPopover';
import StaticLayersGL from './StaticLayersGL/StaticLayersGL';
import useDeckOverlay from './useDeckOverlay';

const DeckGLNext = React.memo(({ map, removedID, activeQueueTab }) => {
  const mapProvider = useSelector(state => state.sinatra.ui.mapProvider);

  const overlay = useDeckOverlay(mapProvider);

  useEffect(() => {
    if (map && overlay) {
      overlay.setMap(map.mapInstance);
    }
  }, [map, overlay]);

  return (
    <>
      <JurisdictionGL overlay={overlay} />
      <CallsGL map={map} overlay={overlay} activeQueueTab={activeQueueTab} />
      <MapPopover overlay={overlay} />
      <IncidentMapPopover overlay={overlay} />
      <AxonGLNext overlay={overlay} />
      <EagleEyeGL overlay={overlay} />
      <StaticLayersGL overlay={overlay} removedID={removedID} />
      <DynamicLayersGL overlay={overlay} />
      <GisSearchGL map={map} overlay={overlay} />
    </>
  );
});

export default DeckGLNext;
